import dayjsUtil from './dayjs'

export const getQuarter = (): number => dayjsUtil(new Date()).subtract(1, 'day').quarter()
